import { useAuth0 } from '@auth0/auth0-react';
import { SignOutIcon } from '@phosphor-icons/react';
import { getAccessToken } from 'api/accessToken';
import { DotLoader } from 'components/DotLoader';
import { Header } from 'components/Header';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'redux/store';
import { Button } from 'ui-library/components/Button/Button';
import { resetReduxState } from 'utils/reduxReset';
import s from './OrgDisabledPage.module.scss';

const POLL_INTERVAL_MS = 10_000;

export const OrgDisabledPage = () => {
  'use memo';

  const dispatch = useAppDispatch();
  const { getAccessTokenSilently, logout } = useAuth0();
  const [isRevalidating, setIsRevalidating] = useState(true);

  useEffect(() => {
    const revalidateOrgStatus = async () => {
      try {
        await getAccessToken(true);
      } catch (error: unknown) {
        console.error('Failed to revalidate org status:', error);
      }

      setIsRevalidating(false);
    };

    void revalidateOrgStatus();
    const interval = setInterval(() => void revalidateOrgStatus(), POLL_INTERVAL_MS);

    return () => {
      clearInterval(interval);
    };
  }, [getAccessTokenSilently, dispatch]);

  if (isRevalidating) {
    return <DotLoader fullScreen />;
  }

  return (
    <div className={s.pageWrapper}>
      <Header />
      <div className={s.container}>
        <p className={s.title}>Your organization has been disabled</p>
        <p className={s.description}>
          Please contact <a href="mailto:support@ankar.ai">support@ankar.ai</a> if you require assistance
        </p>
        <Button
          className={s.logoutButton}
          variant="secondary-dark"
          startAdornment={<SignOutIcon />}
          onClick={() => {
            resetReduxState(dispatch);
            void logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            });
          }}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};
